/**
 * 上云错误分类：决定是否自动重试。
 */

export function isRetryableUploadError(error) {
  if (!error) return false
  if (error.code === 'ECONNABORTED' || error.message === 'Network Error') {
    return true
  }
  const status = error.response && error.response.status
  if (!status) return true
  if (status >= 500) return true
  if (status === 408 || status === 429) return true
  return false
}

export function extractErrorMessage(error) {
  if (!error) return '未知错误'
  if (typeof error === 'string') return error
  if (error.response && error.response.data) {
    const data = error.response.data
    return data.errMessage || data.message || `HTTP ${error.response.status}`
  }
  return error.message || String(error)
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
